/**
 * QA follow-up (Phase 3, Defect B): the persistent header lane stack's own
 * Y offsets from `topReserved` - pure and framework-free (same split as
 * `mapEvents.ts`/`palette.ts`) so the spacing invariant manual QA found
 * broken is directly testable without a Phaser scene. `VisualFeedbackController`
 * is the only caller; it positions its actual Text objects from these.
 *
 * Manual QA found the SKILL lane's own WORMHOLE BITE!/WORMHOLE CLUTCH!
 * text (bold 16px) directly overlapping the persistent WORMHOLE countdown
 * badge (bold 13px) right below it at the previous 22px gap - two bold
 * lines that size need more clearance than their nominal font sizes
 * suggest. `STATUS_WORMHOLE_Y_OFFSET` widens that gap; `STATUS_ROW_GAP`
 * (between the WORMHOLE and SPEED TRIAL badges, same font size as each
 * other) keeps its previous, never-flagged spacing.
 */
export const HEADLINE_Y_OFFSET = 52;
export const SKILL_Y_OFFSET = 74;
export const STATUS_WORMHOLE_Y_OFFSET = 114;
export const STATUS_ROW_GAP = 24;
export const STATUS_SPEED_TRIAL_Y_OFFSET = STATUS_WORMHOLE_Y_OFFSET + STATUS_ROW_GAP;

/**
 * The lowest Y (relative to `topReserved`) the transient near-snake label
 * may ever render at - just below the full persistent header lane stack
 * above, plus a small margin for the SPEED TRIAL badge's own text height.
 * A bite/skill event near the TOP rows of the board can otherwise land the
 * near-snake label (positioned at the eaten cell, not a fixed lane)
 * directly on top of the persistent WORMHOLE/SPEED TRIAL status badges -
 * this is the one shared clamp that rules that out centrally, rather than
 * special-casing any one trigger's board position.
 */
export const NEAR_SNAKE_MIN_Y_OFFSET = STATUS_SPEED_TRIAL_Y_OFFSET + 20;

/** The minimum gap two stacked bold header-lane lines need to never visually overlap, given this project's font sizes (13-16px bold) - anything smaller reproduces the exact SKILL-vs-WORMHOLE-badge collision manual QA found. */
export const MIN_SAFE_LANE_GAP = 30;
